<template>
  <v-layout column
    align-center
    justify-end
    hvf-multi-sidebar-block>
    <v-flex align-self-start zoom-control-wrapper v-if="showZoom">
      <hvf-zoom-control 
        :controlSize="controlSize"
        :image="image" 
        :canvasSize="canvasSize" 
        :scroll="scroll"
        @scrollUp="$emit('scrollUp')"
        @scrollDown="$emit('scrollDown')"
        @scrollTo="$emit('scrollTo', $event)" />
    </v-flex>
    <v-flex shrink>
      <v-btn text
        icon
        class="modal-cta"
        @click="previousHVFImage(index)">
        <v-icon>fas fa-caret-left</v-icon>
      </v-btn>
      <index-counter :index="hvfIndex" :count="hvfCount" />
      <v-btn text
        icon
        class="modal-cta next-image-button"
        @click="nextHVFImage(index)">
        <v-icon>fas fa-caret-right</v-icon>
      </v-btn>
    </v-flex>
    <v-flex shrink>
      <select-with-button 
        :value="exSrNo"
        @change="selectHVFExam({exSrNo: $event, index})"
        :items="hvfExams"
        :icon-button="true"
        item-text="dateDisplay"
        item-value="exSrNo"
        class="toolbar-select hvf-exam-select"/>
    </v-flex>
  </v-layout>
</template>

<script>
import selectWithButton from "../../controls/SelectWithButton";
import indexCounter from "../IndexCounter";
import hvfZoomControl from "./HVFZoomControl";
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "hvfMultiSidebarBlock",
  components: { selectWithButton, indexCounter, hvfZoomControl },
  props: ["view", "index", "image", "controlSize", "canvasSize", "scroll"],
  computed: {
    ...mapGetters(["hvfExams"]),
    showZoom() {
      return this.index === 0;
    },
    hvfIndex() {
      return this.view && this.view.index;
    },
    hvfCount() {
      return (this.view && this.view.maxIndex + 1) || 0;
    },
    exSrNo(){
      return this.view && this.view.exam && this.view.exam.exSrNo;
    }
  },
  methods: {
    ...mapActions(["selectHVFExam"]),
    ...mapMutations(["previousHVFImage", "nextHVFImage"])
  }
};
</script>